(function () {
  var mobileQuery = window.matchMedia('(max-width: 1099px)');

  function syncPromoCarouselState(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var viewports = scope.querySelectorAll('.alilao-dual-promo__viewport[data-alilao-categories-track]');

    for (var index = 0; index < viewports.length; index += 1) {
      var viewport = viewports[index];
      viewport.setAttribute('data-categories-auto-rotate', mobileQuery.matches ? 'true' : 'false');

      if (mobileQuery.matches) {
        viewport.style.setProperty('--alilao-dual-promo-mobile-slide-width', viewport.clientWidth + 'px');
      } else {
        viewport.style.removeProperty('--alilao-dual-promo-mobile-slide-width');
      }

      if (!mobileQuery.matches) {
        viewport.scrollLeft = 0;
      }
    }

    window.dispatchEvent(new Event('resize'));
  }

  function initPromoCarouselState(root) {
    syncPromoCarouselState(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPromoCarouselState(document);
    });
  } else {
    initPromoCarouselState(document);
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      syncPromoCarouselState(document);
    });
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(function () {
      syncPromoCarouselState(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initPromoCarouselState(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target) {
      initPromoCarouselState(event.target);
    }
  });
})();